// extracted by mini-css-extract-plugin
export default {"container":"list_container__Q4OkJ","page":"list_page__MoD66","main":"list_main__tAWmA","column":"list_column__vLL+A"};